import { JSONSchema7 } from 'json-schema';
import { customSchemas, types as commonTypes } from '@sitebuilder/common';
import Annotations from './Annotations';

export const annotationSchema: JSONSchema7 = {
    type: 'string',
    title: 'Filter Object (deprecated: use "Filter By" instead)',
};

export const annotationsFilter: JSONSchema7 = {
    type: 'object',
    title: '',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
        },
        textTargetId: {
            title: 'Text Target Id',
            type: 'string',
        },
        markerTargetId: {
            title: 'Marker Target Id',
            type: 'string',
        },
        inUse: {
            title: 'Show only in use',
            type: 'boolean',
        },
    },
};

export const annotationsFilterUiSchema = {
    filters: {
        id: { 'ui:widget': 'ResourcePicker' },
        textTargetId: { 'ui:widget': 'ResourcePicker' },
        markerTargetId: { 'ui:widget': 'ResourcePicker' },
        inUse: { 'ui:widget': 'CustomCheckbox' },
    },
};

const schema: JSONSchema7 = {
    title: 'Annotations',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        filterBy: annotationSchema,
        filters: annotationsFilter,
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['filterBy'],
        Filters: ['filters'],
    },
];

const AnnotationsWidget: commonTypes.IWidget | any = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        ...annotationsFilterUiSchema,
    },
    templateView: Annotations,
    id: 'Annotations',
    group: 'data',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default AnnotationsWidget;
